import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Select from 'components/inputs/Select';
import ButtonList from 'components/inputs/ButtonList';
import SkyPulseTable from 'components/SkyPulseTable';
import DatePicker from 'components/inputs/DatePicker';

import styles from './styles.module.css';

const idPrefix = 'UsageKidsGUI';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    dataCyClassName: 'Usage-KidsGUITableColumn-rank',
  },
  {
    name: 'Content ID',
    key: 'content_id',
    size: 'small',
    dataCyClassName: 'Usage-KidsGUITableColumn-contentId',
  },
  {
    name: 'Views',
    key: 'views',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-KidsGUITableColumn-views',
  },
  {
    name: 'Avg view mins',
    key: 'avg_views_min',
    size: 'small',
    dataCyClassName: 'Usage-KidsGUITableColumn-avgViewsMin',
  },
  {
    name: 'Content mins',
    key: 'content_mins',
    size: 'xsmall',
    dataCyClassName: 'Usage-KidsGUITableColumn-contentMin',
  },
  {
    name: 'Avg view %',
    key: 'avg_view_per',
    size: 'xsmall',
    dataCyClassName: 'Usage-KidsGUITableColumn-avgViewPer',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    dataCyClassName: 'Usage-KidsGUITableColumn-passengerPoolPer',
  },
];

const data = [
  {
    rank: '1',
    content_id: 'DFP_0623_27Dresses',
    views: 69020,
    avg_views_min: 104,
    content_mins: 122,
    avg_view_per: '93%',
    passenger_pool_per: '13.8%',
  },
];

const KidsGUI = () => {
  const [selectedEventFilter, setSelectedEventFilter] = useState('last30Days');
  const [selectedMonth, setSelectedMonth] = useState('january2026');

  const months = [
    { name: 'January 2026', id: 'january2026' },
    { name: 'February 2026', id: 'february2026' },
    { name: 'March 2026', id: 'march2026' },
    { name: 'April 2026', id: 'april2026' },
    { name: 'May 2026', id: 'may2026' },
  ];

  const filterOptions = [
    { name: 'Last 30 days', value: 'last30Days' },
    {
      name: (
        <div>
          <Select
            idPrefix={`${idPrefix}-month`}
            data-cy-id={`${idPrefix}-FiltersPanel-month`}
            label="Month: "
            options={months}
            value={selectedMonth}
            onChange={({ target: { value } }) => setSelectedMonth(value)}
          />
        </div>
      ),
      value: 'month',
    },
    {
      name: (
        <div className={styles.datecontainer}>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-from`}
              value={Date.now()}
              label="From:"
              onChange={() => {}}
            />
          </div>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-to`}
              value={Date.now()}
              label="To:"
              onChange={() => {}}
            />
          </div>
        </div>
      ),
      value: 'dateRange',
    },
  ];

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-KidsGUI" className="title_1">
            Kids GUI
          </Col>
        </Row>
        <Row className={styles.filterContainer} noGutters>
          <Col>
            <ButtonList
              key={selectedEventFilter}
              idPrefix="Events-filter"
              name="eventFilters"
              type="radio"
              onChange={(e) => {
                const { value } = e.target;
                setSelectedEventFilter(value);
              }}
              options={filterOptions}
              value={selectedEventFilter}
              arrangementClassName={styles.filterList}
              classname={styles.options}
              testIdPrefix="FlightEventsOverlay"
            />
          </Col>
          <Col md="auto">
            <Button
              className="button_foc"
              data-cy-id="Usage-KidsGUI-FilterButton"
              onClick={() => {}}
            >
              Filter
            </Button>
          </Col>
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={data}
                  title="Last 30 days"
                  onRowClick={() => {}}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default KidsGUI;
